import Common from "../../../Common";

const Value = class extends Common {
	async browse(companyId: id, templateId: id) {
		return this.get(`/company/${companyId}/template/${templateId}/value`);
	}

	async update(companyId: id, templateId: id, fieldId: id, data: { value: any }) {
		return this.patch(`/company/${companyId}/template/${templateId}/value/${fieldId}`, data);
	}
}

export default Value;
